<template>
  <div class="agreement-page">
    <div class="agreement-card">
      <h1 class="agreement-title">用户协议</h1>
      
      <div class="agreement-content">
        <section class="section">
          <h2 class="section-title">一、协议的范围</h2>
          <p class="section-text">
            本协议是您与光星乐动平台（以下简称"本平台"）之间关于您使用本平台服务所订立的协议。
            本平台向您提供包括但不限于直播、视频上传、社交互动等服务。
          </p>
        </section>

        <section class="section">
          <h2 class="section-title">二、账号注册与使用</h2>
          <p class="section-text">
            1. 您在使用本平台服务前需要注册一个账号。您应当提供真实、准确的个人信息，
            并在信息变更时及时更新。
          </p>
          <p class="section-text">
            2. 您的账号仅限本人使用，不得转让、出借或共享给他人使用。
            如发现账号异常，请立即联系客服。
          </p>
          <p class="section-text">
            3. 您应当妥善保管账号密码，因您保管不善导致的损失由您自行承担。
          </p>
        </section>

        <section class="section">
          <h2 class="section-title">三、用户行为规范</h2>
          <p class="section-text">
            1. 您在使用本平台服务时，应当遵守法律法规，尊重社会公德，
            不得发布违法违规内容。
          </p>
          <p class="section-text">
            2. 禁止发布以下内容：
          </p>
          <ul class="list">
            <li>违反宪法确定的基本原则的；</li>
            <li>危害国家安全，泄露国家秘密的；</li>
            <li>损害国家荣誉和利益的；</li>
            <li>煽动民族仇恨、民族歧视的；</li>
            <li>破坏国家宗教政策，宣扬邪教和封建迷信的；</li>
            <li>散布谣言，扰乱社会秩序，破坏社会稳定的；</li>
            <li>散布淫秽、色情、赌博、暴力、凶杀、恐怖内容的；</li>
            <li>侮辱或者诽谤他人，侵害他人合法权益的。</li>
          </ul>
        </section>

        <section class="section">
          <h2 class="section-title">四、知识产权</h2>
          <p class="section-text">
            1. 您在本平台上传、发布的原创内容，知识产权归您所有。
            您授予本平台非独占的使用权，用于平台运营和推广。
          </p>
          <p class="section-text">
            2. 未经权利人许可，您不得在本平台发布他人享有知识产权的内容。
          </p>
        </section>

        <section class="section">
          <h2 class="section-title">五、隐私保护</h2>
          <p class="section-text">
            1. 本平台重视您的隐私保护，将按照《隐私政策》收集、使用和保护您的个人信息。
          </p>
          <p class="section-text">
            2. 未经您同意，本平台不会向第三方提供您的个人信息，
            但法律法规另有规定的除外。
          </p>
        </section>

        <section class="section">
          <h2 class="section-title">六、免责声明</h2>
          <p class="section-text">
            1. 本平台不对用户发布的内容的真实性、准确性负责。
          </p>
          <p class="section-text">
            2. 因不可抗力或第三方原因导致的服务中断，本平台不承担责任。
          </p>
          <p class="section-text">
            3. 您使用本平台服务产生的风险由您自行承担。
          </p>
        </section>

        <section class="section">
          <h2 class="section-title">七、协议的变更与终止</h2>
          <p class="section-text">
            1. 本平台有权根据需要修改本协议，修改后的协议将在平台公布。
            如您不同意修改内容，请停止使用本平台服务。
          </p>
          <p class="section-text">
            2. 如您违反本协议，本平台有权暂停或终止向您提供服务。
          </p>
        </section>

        <section class="section">
          <h2 class="section-title">八、其他</h2>
          <p class="section-text">
            1. 本协议的订立、执行和解释及争议的解决均适用中华人民共和国法律。
          </p>
          <p class="section-text">
            2. 如本协议的任何条款被认定为无效，不影响其他条款的效力。
          </p>
          <p class="section-text">
            3. 本协议最终解释权归光星乐动平台所有。
          </p>
        </section>

        <section class="section">
          <h2 class="section-title">九、联系我们</h2>
          <p class="section-text">
            如您对本协议有任何疑问，请通过以下方式联系我们：
          </p>
          <p class="section-text">
            公司名称：北京光星乐动科技有限公司
          </p>
          <p class="section-text">
            公司地址：北京市大兴区经济开发区科苑路9号3号楼三层T1389室
          </p>
          <p class="section-text">
            ICP备案号：京ICP备2025141949号-1
          </p>
          <!-- <p class="section-text">
            客服邮箱：support@tiantong.com
          </p>
          <p class="section-text">
            客服电话：400-123-4567
          </p> -->
        </section>
      </div>

      <div class="agreement-footer">
        <p class="update-time">更新时间：2026年6月20日</p>
        <!-- <button class="btn-accept" @click="acceptAgreement">我已阅读并同意</button> -->
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AgreementPage',
  methods: {
    acceptAgreement() {
      this.$emit('accept')
      this.$message.success('已同意用户协议')
    }
  }
}
</script>

<style scoped lang="scss">
// B站直播风格令牌：粉 #fb7299 / hover #ff85ad / 浅粉 #fff0f5
// 文字 #18191c #61666d #9499a0 / 边框 #e3e5e7 / 分割 #f1f2f3 / 底 #f4f4f5

// 页面容器（由外层 .content 滚动，禁止 100vh 撑高）
.agreement-page {
  min-height: 100%;
  background: #f4f4f5;
  padding: 24px 20px 32px;
  box-sizing: border-box;
}

// 协议白色卡片
.agreement-card {
  max-width: 820px;
  margin: 0 auto;
  background: #fff;
  border: 1px solid #e3e5e7;
  border-radius: 8px;
  padding: 32px 36px;
  box-sizing: border-box;
}

// 协议主标题
.agreement-title {
  font-size: 20px;
  font-weight: 600;
  color: #18191c;
  text-align: center;
  margin: 0 0 8px;
}

// 协议内容
.agreement-content {
  margin-bottom: 24px;
}

// 章节
.section {
  margin-bottom: 24px;

  &:last-child {
    margin-bottom: 0;
  }

  .section-title {
    position: relative;
    font-size: 16px;
    font-weight: 600;
    color: #18191c;
    margin: 0 0 12px;
    padding-left: 10px;

    // 小粉条层级标记
    &::before {
      content: '';
      position: absolute;
      left: 0;
      top: 50%;
      transform: translateY(-50%);
      width: 3px;
      height: 14px;
      background: #fb7299;
      border-radius: 2px;
    }
  }

  .section-text {
    font-size: 14px;
    color: #61666d;
    line-height: 1.8;
    margin: 0 0 8px;
    text-align: justify;
  }

  // 保留默认序号样式，避免全局 reset 影响
  .list {
    list-style: disc;
    margin: 8px 0;
    padding-left: 24px;

    li {
      font-size: 14px;
      color: #61666d;
      line-height: 1.8;
      margin-bottom: 4px;
      padding-left: 2px;
    }
  }
}

// 底部区域
.agreement-footer {
  text-align: center;
  padding-top: 20px;
  border-top: 1px solid #f1f2f3;

  .update-time {
    font-size: 12px;
    color: #9499a0;
    margin: 0;
  }

  .btn-accept {
    padding: 10px 40px;
    background: #fb7299;
    border: none;
    border-radius: 6px;
    color: #fff;
    font-size: 14px;
    cursor: pointer;
    transition: background 0.2s ease;

    &:hover {
      background: #ff85ad;
    }
  }
}
</style>